import { useSelector } from 'react-redux';
import { getUserData } from 'store/selectors/user';
import { useGetAllSurveysQuery, useUpdateSurveyMutation } from 'store/services/feedbackGroup';
import Table from 'style-guide/Table';
import AttachSurveyModalWrapper from './style/AttachSurveyModalWrapper';
import { getAttachSurveyModalColumns } from './AttachSurveyModalColumns';

const AttachSurveyModal = ({ params: { chapterId, id, onClose, isReplace, surveyId } }) => {
  const [updateSurvey] = useUpdateSurveyMutation();

  const user = useSelector(getUserData);

  const { data } = useGetAllSurveysQuery({ userId: user.id });

  const formattedData =
    data
      ?.filter((survey) => !(isReplace && survey.id === surveyId))
      .map((survey) => ({
        survey: survey.title,
        linkedLC: survey.courses || 'N/A',
        createdBy: survey.user || 'Unknown',
        actions: { surveyId: survey.id, chapterId, courseId: id },
        lastUpdated: survey.updatedAt
          ? new Date(survey.updatedAt).toLocaleDateString()
          : new Date(survey.createdAt).toLocaleDateString(),
      })) || [];

  return (
    <AttachSurveyModalWrapper>
      <Table
        columns={getAttachSurveyModalColumns(updateSurvey, onClose, isReplace)}
        rowKey={(e) => e.key}
        data={formattedData}
      />
    </AttachSurveyModalWrapper>
  );
};
export default AttachSurveyModal;
